// extracted by mini-css-extract-plugin
export default {"bottomBoxRow":"style_bottomBoxRow__RCQSt"};